import dateFormat from "dateformat";

export const fromCustomDate = (custom) => {
  if (custom && custom.length >= 8) {
    const year = custom.substring(0, 4);
    const month = custom.substring(4, 6);
    const day = custom.substring(6, 8);
    // console.log("-----from----");
    // console.log(`year: ${year}`);
    // console.log(`month: ${month}`);
    // console.log(`day: ${day}`);
    // console.log(new Date(year, month - 1, day));
    return new Date(year, month - 1, day);
  }

  return new Date();
};

export const toCustomDate = (dateValue) => {
  const date = dateValue || new Date();

  const [year, month, day] = [
    date.getFullYear(),
    date.getMonth().toString().padStart(2, "0"),
    date.getDate().toString().padStart(2, "0"),
  ];
  const [hour, minutes, seconds] = [
    date.getHours().toString().padStart(2, "0"),
    date.getMinutes().toString().padStart(2, "0"),
    date.getSeconds().toString().padStart(2, "0"),
  ];

  // console.log("-----to----");
  // console.log(`year: ${year}`);
  // console.log(`month: ${(parseInt(month) + 1).toString().padStart(2, "0")}`);
  // console.log(`day: ${day}`);
  // console.log(date);

  return `${year}${(parseInt(month) + 1)
    .toString()
    .padStart(2, "0")}${day}${hour}${minutes}${seconds}`;
};

export const calculateDate = (value) =>
  dateFormat(fromCustomDate(value), "dd/mm/yyyy");
